import React from "react";
import { LegalPage, LegalSection } from "@/components/Legal";

export default function PrivacyPolicy() {
  return (
    <LegalPage title="Privacy Policy" updated="July 2026" testid="privacy-page">
      <LegalSection title="What we collect">
        <p>
          Boat RV Moving (boatrvmoving.com) is a marketplace connecting boat and RV owners with transport
          drivers. To run it, we collect:
        </p>
        <ul className="list-disc pl-5 mt-2 space-y-1.5">
          <li>Account details — name, email, phone number, password (stored only as a secure hash).</li>
          <li>Driver verification data — USDOT number, FMCSA SAFER lookup results, driver's license and insurance documents.</li>
          <li>Listing and haul data — pickup/delivery locations, vehicle details, bids, messages, ratings, and haul photos.</li>
          <li>Usage data — logins, page views, notification and email/SMS delivery records.</li>
        </ul>
      </LegalSection>

      <LegalSection title="How we use it">
        <p>
          We use this information to operate the marketplace: verifying drivers against the FMCSA database,
          matching hauls to drivers, processing bids and payments, sending service notifications, and keeping
          the platform safe. We do not sell your personal information.
        </p>
      </LegalSection>

      <LegalSection title="SMS / text messaging">
        <p>
          If you provide your phone number, you consent to receive SMS messages from Boat RV Moving, including
          service updates and notifications (for example: new bids on your haul, bid wins, pickup and
          delivery updates, and a weekly digest of matching hauls). Message frequency varies. Message and
          data rates may apply.
        </p>
        <p className="mt-2">
          You can opt out at any time by replying <strong className="text-zinc-200">STOP</strong> to any
          message, or by turning off text alerts in your Profile. Reply{" "}
          <strong className="text-zinc-200">HELP</strong> for help, or contact us at{" "}
          <a href="mailto:info@boatrvmoving.com" className="text-[#FF3B30] hover:text-white underline underline-offset-2">info@boatrvmoving.com</a>.
          Opting out of texts does not affect email notifications or your account.
        </p>
      </LegalSection>

      <LegalSection title="Mobile opt-in data">
        <p>
          <strong className="text-zinc-200">
            Mobile opt-in data will not be shared with third parties.
          </strong>{" "}
          Your phone number and your SMS consent status are used only to deliver Boat RV Moving's own messages
          to you. They are never sold, rented, or shared with third parties for their marketing purposes.
        </p>
      </LegalSection>

      <LegalSection title="Documents & photos">
        <p>
          Verification documents and haul photos are stored in encrypted, access-controlled object storage.
          Documents are visible only to our review team; haul photos are visible only to the shipper and
          driver on that haul (and platform administrators for support and dispute resolution).
        </p>
      </LegalSection>

      <LegalSection title="Service providers">
        <p>
          We use a small number of processors to run the service — cloud hosting, email delivery, SMS
          delivery (Twilio), payment processing (Stripe), and government data lookup (FMCSA SAFER). They
          receive only the data needed to perform their function and may not use it for their own purposes.
        </p>
      </LegalSection>

      <LegalSection title="Retention & your choices">
        <p>
          We keep account and haul records while your account is active and as required for legal, tax, and
          dispute purposes. You can update your phone and notification preferences in your Profile, opt out
          of SMS at any time by replying STOP, and request account deletion by emailing us.
        </p>
      </LegalSection>

      <LegalSection title="Changes">
        <p>
          If we change this policy we'll update the date above and, for material changes, notify you by
          email or in the app.
        </p>
      </LegalSection>
    </LegalPage>
  );
}
